import React from "react";
import { motion } from "framer-motion";
import { TID } from "@/lib/testIds";
import PhoneMockup from "@/components/sentinel/PhoneMockup";
import { useT } from "@/lib/i18n";

const EASE = [0.22, 1, 0.36, 1];

export default function HowItWorks() {
    const { t } = useT();
    const steps = t("how.steps") || [];
    return (
        <section
            id="come-funziona"
            data-testid={TID.how.root}
            className="bg-sn-paper-2 py-24 md:py-40 relative overflow-hidden"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.4 }}
                    transition={{ duration: 0.9, ease: EASE }}
                    className="flex items-baseline gap-4 mb-16 md:mb-24"
                >
                    <span className="font-mono-e text-[11px] uppercase tracking-[0.3em] text-sn-blue">
                        {t("how.eyebrow")}
                    </span>
                    <span className="hairline flex-1" />
                    <span className="font-mono-e text-[11px] uppercase tracking-[0.3em] text-sn-ink-2">
                        {t("how.count")}
                    </span>
                </motion.div>

                <motion.h2
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.4 }}
                    transition={{ duration: 0.9, ease: EASE }}
                    className="font-serif text-5xl md:text-7xl leading-[0.98] tracking-tight max-w-3xl text-sn-ink"
                >
                    {t("how.headline_a")}{" "}
                    <em className="italic text-sn-blue">
                        {t("how.headline_b")}
                    </em>
                    .
                </motion.h2>

                <div className="mt-20 md:mt-28 grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-6 items-start">
                    {steps.map((s, i) => (
                        <motion.div
                            key={i}
                            data-testid={TID.how.step(i + 1)}
                            initial={{ opacity: 0, y: 60 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 1, delay: i * 0.15, ease: EASE }}
                            className="flex flex-col items-center"
                        >
                            <PhoneMockup variant={i + 1} />
                            <div className="mt-10 w-full max-w-[300px] text-center">
                                <div className="font-mono-e text-[10px] tracking-[0.3em] text-sn-blue uppercase mb-2">
                                    {t("how.stepLabel")} 0{i + 1}
                                </div>
                                <h3 className="font-serif text-3xl md:text-4xl text-sn-ink">
                                    {s.title}
                                </h3>
                                <p className="mt-3 text-sn-ink-2 leading-relaxed">
                                    {s.text}
                                </p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
